import type { FontSpec, GridLineOptions, LinearScale, TickOptions } from 'chart.js';

export const BD_NUMERIC_CHART_AXIS_OPTIONS_TICKS_DEFAULT: TickOptions | any = {
  callback: (value: any) => {
    return new Intl.NumberFormat().format(value);
  },
};

export const BD_NUMERIC_CHART_AXIS_OPTIONS_GRID_LINES_DEFAULT:
  | GridLineOptions
  | any = {
  color: 'rgba(0,0,0,0.07)',
  drawOnChartArea: true,
  tickLength: 4,
};

export const BD_NUMERIC_CHART_AXIS_OPTIONS_SCALE_LABELS_DEFAULT:
  | FontSpec
  | any = {
  family: 'Montserrat',
};

export const BD_NUMERIC_CHART_AXIS_OPTIONS_DEFAULT: LinearScale | any = {
  type: 'linear',
  ticks: BD_NUMERIC_CHART_AXIS_OPTIONS_TICKS_DEFAULT,
  grid: BD_NUMERIC_CHART_AXIS_OPTIONS_GRID_LINES_DEFAULT,
  scaleLabel: BD_NUMERIC_CHART_AXIS_OPTIONS_SCALE_LABELS_DEFAULT,
};
